export default ({ request }) => ({
  dfInspectorListApi(data = {}) {
    return request({
      url: '/dfs/df/inspector/list',
      method: 'post',
      data,
    })
  },
  dfInspectorAddApi(data = {}) {
    return request({
      url: '/dfs/df/inspector/add',
      method: 'post',
      data,
    })
  },
  dfInspectorDelApi(data = {}) {
    return request({
      url: '/dfs/df/inspector/del',
      method: 'post',
      data,
    })
  },
  dfInspectorSetManagerApi(data = {}) {
    return request({
      url: '/dfs/df/inspector/setManager',
      method: 'post',
      data,
    })
  },
  dfInspectorSetInspectorApi(data = {}) {
    return request({
      url: '/dfs/df/inspector/setInspector',
      method: 'post',
      data,
    })
  },
})
